import {
  Gefahr,
  Produktlinie,
  UebergreifendItem,
  ZusatzoptionItem,
} from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import {
  isExtremwetterUWProcessNecessaryNoVorschaeden,
  ExtremwetterUWProcessQuery,
} from '@ps20-frontend/selector';
import { IAppState } from '../../../store/appState';
import { ZusatzoptionItemVWG } from '../../../store/models/zusatzoptionenVWG.model';
import { selectGisFlutzone } from './gisDaten.selector';

export const selectSelectedProduktlinie = (state: IAppState): Produktlinie =>
  getSelectedProduktlinie(state.produkt);

export function mapStateToPremiumAndExtremwetterDisabledSelectorTo(
  state: IAppState,
): ExtremwetterUWProcessQuery {
  return {
    elementarSelbstbehaltId: state.elementarSelbstbehalt?.id,
    activateElementar: state.vorbelegungen?.activateElementar,
    flutzone: selectGisFlutzone(state),
    featureToggles: state.transientState?.featureToggles,
    vorschaedenVorhanden: state.vorschaeden?.vorhanden,
    vertragsoptionen: state.vertragsoptionen,
    elementarVorschadenCountFromRisikoortService:
      state.vorschaeden?.elementarVorschaden.countFromRisikoortService,
    risikoortZuerszone: state.risikoort?.zuerszone,
    elementarVorschaedenCount: state.vorschaeden?.elementarVorschaden.count,
  };
}

export const premiumAndExtremwetterNoVorschaedenDisabled = (state: IAppState): boolean => {
  return isExtremwetterUWProcessNecessaryNoVorschaeden(
    mapStateToPremiumAndExtremwetterDisabledSelectorTo(state),
  );
};

export const selectZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItemVWG> => {
  return selectSelectedProductZusatzoptionItems(state);
};

const selectSelectedProductZusatzoptionItems = (state: IAppState): ZusatzoptionItem[] =>
  getSelectedProduktlinie(state.produkt)?.zusatzoptionen || [];

export type SelectZusatzoptionItemsReturnType = ReturnType<typeof selectZusatzoptionItems>;

export const selectProduktlinien = (state: IAppState): Array<Produktlinie> =>
  state.produkt?.produktlinien || [];

export const selectUebergreifendeLeistungen = (state: IAppState): Array<UebergreifendItem> =>
  state.produkt?.uebergreifend || [];

export const selectSelectedZusatzoptionItems = (state: IAppState): Array<ZusatzoptionItem> => {
  return selectSelectedProductZusatzoptionItems(state).filter(elem => elem.isSelected);
};

export const selectFormattedProduktlinienGefahren = (state: IAppState): Array<string> => {
  return selectProduktlinien(state)
    .filter(tarifItem => tarifItem.gefahren?.length > 0)
    .map((tarifItem: Produktlinie) => tarifItem.gefahren)
    .map(getGefahrenAsString)
    .map(getGefahrenCommaSeperated);
};

export const selectGefahrenByProduktlinie = (state: IAppState): Array<Gefahr> => {
  return getSelectedProduktlinie(state.produkt)?.gefahren || [];
};

function getGefahrenAsString(gefahrArray: Array<Gefahr>): string[] {
  return gefahrArray
    .filter((gefahr: Gefahr) => gefahr.isSelected)
    .map((gefahr: Gefahr) => gefahr.label);
}

function getGefahrenCommaSeperated(gefahrArrayAsStrings: Array<string>): string {
  return gefahrArrayAsStrings.toString().replace(/,/gi, ', ');
}

export const selectSelectedProduktlinieIndex = (state: IAppState): number => {
  return selectProduktlinien(state).findIndex(produktlinie => produktlinie.selected);
};
